module.exports = __webpack_public_path__ + "static/008-a28732821711178d0b1aadc92c7d1376.jpg";